import React from 'react'
import { Doughnut } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js'

ChartJS.register(ArcElement, Tooltip)

interface RadialProgressProps {
    progress: number // nilai antara 0-100
    color?: string
    size?: number
}

const RadialProgress: React.FC<RadialProgressProps> = ({
    progress,
    color = '#0d6efd',
    size = 120
}) => {
    const data = {
        datasets: [
            {
                data: [progress >= 100 ? 100 : progress, 100 - progress],
                backgroundColor: [color, '#e4e6ef'],
                borderWidth: 0,
                cutout: '70%',
            },
        ],
    }
    
    const options = {
        rotation: 0,
        circumference: 360,
        plugins: {
            tooltip: { enabled: false },
        },
    }

    return (
        <div
            style={{
                width: size,
                height: size,
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}
        >
            <Doughnut data={data} options={options} />
            <div
                style={{
                    position: 'absolute',
                    fontWeight: 'bold',
                    fontSize: '14px',
                    marginTop: '10px',
                }}
            >
                {Math.round(progress)}%
            </div>
        </div>
    )
}

export default RadialProgress
